import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import ca from "../../../messages/ca.json"
import es from "../../../messages/es.json"
import en from "../../../messages/en.json"

// Read persisted locale from localStorage (Zustand persist key)
function getPersistedLocale(): string {
	try {
		const raw = localStorage.getItem("locale-store")
		if (raw) {
			const parsed = JSON.parse(raw)
			const locale = parsed?.state?.locale
			if (locale && ["ca", "es", "en"].includes(locale)) return locale
		}
	} catch {}
	return "ca"
}

i18n.use(initReactI18next).init({
	resources: {
		ca: { translation: ca },
		es: { translation: es },
		en: { translation: en },
	},
	lng: getPersistedLocale(),
	fallbackLng: "ca",
	interpolation: {
		// Use single braces like next-intl: {variable} instead of {{variable}}
		prefix: "{",
		suffix: "}",
		escapeValue: false,
	},
	// Flatten nested keys: t("namespace.key") works with nested JSON
	keySeparator: ".",
	nsSeparator: false,
})

export default i18n
